import gsap from "gsap";

export function animateImage(button) {
	const previousFlyingEl = document.querySelector('.cart-flying-image');
	if (previousFlyingEl) return;

	let wrapper = button.closest('.product-card, .js-fly-wrapper');

	if (button.closest('.devices-slider')) {
		wrapper = document.querySelector('.devices-slider .swiper-wrapper .swiper-slide-active .swiper-slide.is-active .js-fly-wrapper')
	}

	if (button.closest('.sticks-slider')) {
		wrapper = document.querySelector('.sticks-slider .swiper-wrapper .swiper-slide-active .swiper-slide.is-active .js-fly-wrapper')
	}

	if (button.closest('.product__grid')) {
		wrapper = document.querySelector('.product__grid .swiper-initialized .swiper-wrapper .swiper-slide-active.js-fly-wrapper') || document.querySelector('.product__grid .swiper-wrapper .js-fly-wrapper');
	}

	const cartBtn = document.querySelector('.js-header-cart-btn');
	console.log('wrapper', wrapper);
	if (!wrapper) return;

	let image = wrapper.querySelector('.product-card__figure img, .js-fly-image');
	console.log('image', image);
	if (!image) return;
	const rect = image.getBoundingClientRect();
	const scaleAdjust = image.dataset.flyImageScale ? +image.dataset.flyImageScale : 1;

	const div = document.createElement('div');
	div.classList.add('cart-flying-image');
	div.innerHTML = `
		<div
			class="cart-flying-image"
			width='${rect.width}px'
			height='${rect.height}px'
			style='
				top: ${window.pageYOffset+rect.y}px;
				left: ${rect.x}px;
				width: ${rect.width}px;
				height: ${rect.height}px;
			'
		>
			<img src="${image.src}">
		</div>
	`;
	document.body.append(div.firstElementChild);

	const flyingEl = document.querySelector('.cart-flying-image');
	const flyingElImage = flyingEl.querySelector('img');

	if (flyingEl && flyingElImage) {
		const cartRect = cartBtn.getBoundingClientRect();
		let scaleFactor = scaleAdjust * (0.5*1/(rect.width/cartRect.width));

		const tl = gsap.timeline();
		tl.to(flyingEl, {
			x: (cartRect.x+ cartRect.width/2) - (rect.x+rect.width/2),
			y: (cartRect.y) - (rect.y+rect.height/2),
			scale: scaleFactor,
			ease: "power2.out",
			duration: 1.2
		});

		tl.to(flyingElImage, {
			yPercent: 100,
			duration: 0.5,
			onComplete: () => {
				flyingEl.remove();
			}
		});
	}
}